"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var TextSpan_meta_1 = require("./TextSpan.meta");

var TextSpan =
/** @class */
function (_super) {
  __extends(TextSpan, _super);

  function TextSpan(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = TextSpan_meta_1.TEXT_SPAN_CATEGORY_KEY;
    _this.componentKey = TextSpan_meta_1.TEXT_SPAN_COMPONENT_KEY;
    _this.ref = react_1.default.createRef();
    return _this;
  }

  Object.defineProperty(TextSpan.prototype, "parentComponentKey", {
    get: function get() {
      return TextSpan_meta_1.TEXT_SPAN_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });

  TextSpan.prototype.componentDidMount = function () {
    this.setFocus();
  };

  TextSpan.prototype.componentDidUpdate = function () {
    this.setFocus();
  };

  TextSpan.prototype.setFocus = function () {
    var shouldFocus = this.props.shouldFocus;

    if (shouldFocus) {
      this.ref.current.focus();
    }
  };

  TextSpan.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        onFocus = _a.onFocus,
        onBlur = _a.onBlur,
        otherProps = __rest(_a, ["children", "onFocus", "onBlur"]);

    return react_1.default.createElement("span", __assign({
      onFocus: onFocus,
      onBlur: onBlur,
      role: 'text'
    }, otherProps, {
      ref: this.ref
    }), children);
  };

  TextSpan = __decorate([mobx_react_1.observer], TextSpan);
  return TextSpan;
}(shared_1.ComponentBase);

exports.TextSpan = TextSpan;
exports.default = shared_1.InjectedStyledComponent(TextSpan, TextSpan_meta_1.TEXT_SPAN_CATEGORY_KEY, TextSpan_meta_1.TEXT_SPAN_PARENT_COMPONENT_KEY, [TextSpan_meta_1.TEXT_SPAN_COMPONENT_KEY]);